import { render } from "./AvailableAcceptanceDetail.vue?vue&type=template&id=546d4c20&scoped=true"
import script from "./AvailableAcceptanceDetail.vue?vue&type=script&lang=ts"
export * from "./AvailableAcceptanceDetail.vue?vue&type=script&lang=ts"

import "./AvailableAcceptanceDetail.vue?vue&type=style&index=0&id=546d4c20&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-546d4c20"

export default script